import request from '@/http/request'


export function getUserIp(query) {
  return request({
    url: '/system/userip/getip',
    method: 'get',
    params: query
  })
}